import React from "react"
import PropTypes from "prop-types"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import { sheetPaths } from "app/static/frontend/imports/desktopPaths"
import SegueLink from "app/static/frontend/middleware/SegueLink"

const CustomColumnColorButton = ({ columnIndex, sheetId }) => (
    <SegueLink to={sheetPaths.setupCustomColumnColors.replace(":sheetId", sheetId).replace(":index", columnIndex)}>
        <Tooltip label={`Setup custom colors for this column.`}>
            <div>
                <Icon name="paint-brush" />
            </div>
        </Tooltip>
    </SegueLink>
)

CustomColumnColorButton.propTypes = {
    sheetId: PropTypes.number.isRequired,
    columnIndex: PropTypes.number.isRequired,
}

CustomColumnColorButton.defaultProps = {}

export default CustomColumnColorButton
